<template>
  <div class="pg-ocr">
    <div
      class="pg-ocr__helper"
      ref="helperRef"
      :style="styleData"
      @click="swichVisible"
      @mousedown="onMousedown"
      @mousemove="onMousemove"
      @mouseup="onMouseup"
    >
      <PgOcrWawa class="pg-ocr__helper-wawa"></PgOcrWawa>
      <span class="pg-ocr__helper-btn"><span>AI助手</span></span>
    </div>
    <PgDialogOcr v-if="isRender" :visible.sync="visible" :ocrTypes="ocrTypes"></PgDialogOcr>
  </div>
</template>
<script setup>
import PgDialogOcr from './dialog-ocr.vue'
import PgOcrWawa from './ocr-wawa.vue'
import { ref } from 'vue'

defineProps({
  ocrTypes: Array,
})

const isRender = ref(false)
const visible = ref(false)
const swichVisible = () => {
  if (!isMove.value) {
    visible.value = !visible.value
    if (visible.value && !isRender.value) {
      isRender.value = true
    }
  }
}

const helperRef = ref(null)
const isMousedown = ref(false)
const styleData = ref({
  top: '200px',
  right: '20px',
})
let disY = 0,
  disX = 0
const isMove = ref(false)
const onMousedown = (event) => {
  disY = event.clientY - helperRef.value.offsetTop
  disX = event.clientX - helperRef.value.offsetLeft
  isMousedown.value = true
  isMove.value = false
}
const onMousemove = (event) => {
  if (isMousedown.value) {
    styleData.value.top = `${event.clientY - disY}px`
    styleData.value.right = `${
      document.body.clientWidth - (event.clientX - disX) - helperRef.value.clientWidth
    }px`
    isMove.value = true
  }
}
const onMouseup = () => {
  isMousedown.value = false
}
</script>
<style lang="scss">
@import '../style/ocr.scss';
</style>
